import React from 'react'
import Text from '../../../atoms/text/Text'
import InlineGroup from '../../../atoms/inlinegroup/InlineGroup'
import Icon from '../../../atoms/icon/Icon'
import './YAxisIndicator.scss'

interface Props {
  name: string
  topIndicator: string
  bottomIndicator: string
}

const YAxisIndicator: React.FC<Props> = ({ name, topIndicator, bottomIndicator }) => {
  return (
    <InlineGroup className='vertical-text' spread verticalCenter>
      <Icon type='arrow'></Icon>
      <InlineGroup fullHeight spread className='vertical pt-2 pb-2'>
        <Text size='lg' vertical center>{topIndicator}</Text>
        <Text size='lg' vertical center>{`(${name})`}</Text>
        <Text size='lg' vertical center>{bottomIndicator}</Text>
      </InlineGroup>
      <Icon type='arrow' className='rotate'></Icon>
    </InlineGroup>
  )
}

export default YAxisIndicator
              